import React from 'react'
import Layout from '../../layout'

function OrgDetails() {
  return (
    <>
        <Layout props='memberdetails'></Layout>
    </>
  )
}

export default OrgDetails 